import { Component, OnInit } from '@angular/core';
import { SideBarService } from '../../shared/sidebar/sidebar.service';

@Component({
  selector: 'ls-waiter-mobile',
  templateUrl: './waiter-mobile.component.html'
})
export class WaiterMobileComponent implements OnInit {
  constructor(private sideBarService: SideBarService) {}

  public ngOnInit(): void {
    this.sideBarService.close();
  }
}
